import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Mark } from './ui/kit';
import { MARKS } from '../lib/marks';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-100 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full text-center"
      >
        {/* The wrong-turn drawing, in the marketing site's engraved vocabulary. */}
        <motion.div
          initial={{ scale: 0.94, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.1, duration: 0.4 }}
        >
          <Mark src={MARKS.wrongTurn} size="xl" className="mx-auto" />
        </motion.div>

        {/* Message */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <div className="mx-auto mt-6 mb-5 h-px w-10 bg-zinc-300" />
          <div className="font-mono text-[11px] uppercase tracking-eyebrow text-zinc-500 mb-2.5">
            Error 404
          </div>
          <h1 className="text-2xl font-display font-bold text-primary mb-3">
            Page not found
          </h1>
          <p className="text-muted mb-8 leading-relaxed">
            This address doesn&apos;t lead anywhere — it may have moved, or never existed.
            Both routes below go somewhere real.
          </p>
        </motion.div>

        {/* Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="flex flex-col sm:flex-row gap-3 justify-center"
        >
          <Link
            to="/dashboard"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary hover:bg-ink-soft text-white font-medium rounded-full transition-all duration-200 hover:-translate-y-0.5"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
              />
            </svg>
            Go to Dashboard
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-zinc-200 hover:bg-zinc-300 text-primary font-medium rounded-xl transition-all duration-200"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
              />
            </svg>
            Go Back
          </button>
        </motion.div>

        {/* Help Link */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-8 text-sm text-muted"
        >
          Need help?{' '}
          <a
            href="mailto:hello@foundlio.com"
            className="text-primary underline-offset-4 hover:underline font-medium"
          >
            Email us
          </a>
        </motion.p>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
